import {delay, noop} from 'lodash'
import {createLogger} from 'logging'
import {ITEM_TYPES} from 'powtoon-document/consts'

let timeouts

const logger = createLogger('userTrackingService')

const trackEventByParams = ({category, action, label, value, extraData}) => {
  if(process.env.NODE_ENV === 'production' && !window.trackEventByParams) {
    logger.error(new Error('window.trackEventByParams is missing in production.'))
  }
  const trackingFunc = window.trackEventByParams || noop
  return trackingFunc(category, action, label, value, extraData)
}

export default {
  report(eventObj) {
    trackEventByParams(eventObj)
  },

  logError: logger.error,

  trackEventByParams(category, action, label, value) {
    trackEventByParams({category, action, label, value})
  },
  setStoryBoardTimeSpentTracker() {
    timeouts = [0, 1, 2, 4, 15, 30, 90, 180, 360].map(
      min => delay(
        () => {this.trackEventByParams(`time_in_story_${min}_min`, 'duration', 'storyboard')},
        20000 * min
      )
    )
  },
  clearStoryBoardTimeSpentTracker() {
    timeouts.forEach(item => clearTimeout(item))
  },
  getSpriteType(sprite) {
    return sprite.assetType || (sprite.itemType === ITEM_TYPES.IMAGE ? 'images' : sprite.itemType)
  }
}
